export class InvalidParametersError extends Error {
  static name = 'InvalidParametersError'
  name = 'InvalidParametersError'
}
